/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ReorderTransactionCodesRequest
 */
export interface ReorderTransactionCodesRequest {
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof ReorderTransactionCodesRequest
     */
    orderedIds: Array<ApiUserTasksGetPageParameter>;
}

/**
 * Check if a given object implements the ReorderTransactionCodesRequest interface.
 */
export function instanceOfReorderTransactionCodesRequest(value: object): value is ReorderTransactionCodesRequest {
    if (!('orderedIds' in value) || value['orderedIds'] === undefined) return false;
    return true;
}

export function ReorderTransactionCodesRequestFromJSON(json: any): ReorderTransactionCodesRequest {
    return ReorderTransactionCodesRequestFromJSONTyped(json, false);
}

export function ReorderTransactionCodesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReorderTransactionCodesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'orderedIds': ((json['orderedIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
    };
}

export function ReorderTransactionCodesRequestToJSON(json: any): ReorderTransactionCodesRequest {
    return ReorderTransactionCodesRequestToJSONTyped(json, false);
}

export function ReorderTransactionCodesRequestToJSONTyped(value?: ReorderTransactionCodesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderedIds': ((value['orderedIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
    };
}

